/**
 * TaskNotificationQueueService
 * Service for TaskNotificationQueue entity operations
 * Route: api/task-notification-queue
 */
import { CrudService } from '../base/CrudService';
/**
 * TaskNotificationQueueService
 * Handles task notification queue CRUD operations
 */
export class TaskNotificationQueueService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskNotificationQueueService.DEFAULT_SERVICE_PATH,
            basePath: TaskNotificationQueueService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET PENDING ====================
    /**
     * Get all pending notification queue items
     * GET api/task-notification-queue/pending
     */
    async getPending() {
        const response = await this.getPendingRaw();
        return response.data ?? [];
    }
    /**
     * Get all pending notification queue items with full response
     */
    getPendingRaw() {
        const endpoint = this.getEndpoint('pending', 'pending');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET BY TASK ID ====================
    /**
     * Get all queue items for a task
     * GET api/task-notification-queue/task/{taskId}
     */
    async getByTaskId(taskId) {
        const response = await this.getByTaskIdRaw(taskId);
        return response.data ?? [];
    }
    /**
     * Get all queue items for a task with full response
     */
    getByTaskIdRaw(taskId) {
        const endpoint = this.getEndpoint('by-task', `task/${taskId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
TaskNotificationQueueService.DEFAULT_SERVICE_PATH = 'tasks';
TaskNotificationQueueService.BASE_PATH = 'api/task-notification-queue';
//# sourceMappingURL=TaskNotificationQueueService.js.map